@if (collapsed) {
  <mat-nav-list class="collapsed">
    @for (route of routes; track route) {
      <itfg-menu-list-item
        *ngxPermissionsOnly="route.permissions"
        [collapsed]="true"
        (click)="openNestedMenu(route)"
        [config]="route"
      ></itfg-menu-list-item>
    }
  </mat-nav-list>
}

@if (!collapsed) {
  <mat-nav-list class="itfg-layout-nav-menu">
    @for (route of routes; track route) {
      <itfg-menu-list-item
        *ngxPermissionsOnly="route.permissions"
        [collapsed]="false"
        (click)="navigationLinkClicked()"
        [config]="route"
      ></itfg-menu-list-item>
      <!-- <mat-accordion> -->
      @if (
        route.children &&
        route.children.length > 0 &&
        !(route.permissions | isUnauthorized | async)
        ) {
        <mat-expansion-panel
          [expanded]="!isExpanded[route.routerLink]"
          class="shadow-none padding-left-16px navigation-expansion-panel"
          >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div layout-align="center center" flex layout="row">
                <div flex="15">
                  <mat-icon [svgIcon]="route.svg ? route.icon: ''" matListItemIcon>{{ route.icon }}</mat-icon>
                </div>
                <span [translate]="route.label" flex>Route label</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <mat-nav-list flex class="flex-offset-5">
              @for (childRoute of route.children; track childRoute) {
                <itfg-menu-list-item
                  *ngxPermissionsOnly="childRoute.permissions"
                  [collapsed]="false"
                  (click)="navigationLinkClicked()"
                  [config]="childRoute"
                ></itfg-menu-list-item>
                <!-- <mat-accordion> -->
                @if (
                  childRoute.children &&
                  childRoute.children.length > 0 &&
                  !(childRoute.permissions | isUnauthorized | async)
                  ) {
                  <mat-expansion-panel
                    [expanded]="isExpanded[route.routerLink]"
                    class="shadow-none padding-left-16px navigation-expansion-panel"
                    >
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div layout-align="center center" flex layout="row">
                          <div flex="15">
                            <mat-icon [svgIcon]="childRoute.svg ? childRoute.icon: ''" matListItemIcon>{{ childRoute.icon }}</mat-icon>
                          </div>
                          <span [translate]="childRoute.label" flex
                            >Route label</span
                            >
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div flex layout="row">
                        <mat-nav-list flex class="flex-offset-5">
                          @for (child of childRoute.children; track child) {
                            <itfg-menu-list-item
                              *ngxPermissionsOnly="child.permissions"
                              [collapsed]="false"
                              class="padding-left-16px"
                              (click)="navigationLinkClicked()"
                              [config]="child"
                            ></itfg-menu-list-item>
                          }
                        </mat-nav-list>
                      </div>
                    </mat-expansion-panel>
                  }
                <!-- </mat-accordion> -->
              }
            </mat-nav-list>
          </ng-template>
        </mat-expansion-panel>
      }
    <!-- </mat-accordion> -->
  }
</mat-nav-list>
}
